import axios from "axios";

class B2bService {
  private axios = axios.create({
    baseURL: "https://asia-southeast2-amh-b2b.cloudfunctions.net/api-b2b",
  });

  public async getOfferData(params?: { offerCode?: string }) {
    try {
      return await this.axios.get<any>(`/public/get-survey/offer-code/${params?.offerCode}`, {
        headers: {
          "X-Api-Key": "",
        },
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async getLeasing() {
    try {
      return await this.axios.get<any>(`/public/available-leasing/public`, {
        headers: {
          "X-Api-Key": "",
        },
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }
}

export const b2bService = new B2bService();
